import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';

class OptimizationPipelineTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'optimizationPipelineTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<NamedDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NamedDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<GenericTableDto<NamedDto>>}
	 */
	getDetails(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getDetails`, {
					id
				})
				.then(response => resolve(response))
				.catch(reject);
		});
	}
}

export default new OptimizationPipelineTableService();
